import { Box, Flex, Text } from "@mantine/core"
import { ReactNode } from "react"
import classes from "../real.module.css"

// Dashboard card title: bold title with a meta line below (the period or
// scope the figure covers) and an optional right-hand slot.
interface Props {
  title: string
  subtitle?: string
  right?: ReactNode
  leftIcon?: ReactNode
}

export function CardHeader({ title, subtitle, right, leftIcon }: Props) {
  return (
    <Flex className={classes.cardHead} w="100%">
      <Flex gap={8} align="flex-start">
        {leftIcon}
        <Box>
          <Text className={classes.cardTitle}>{title}</Text>
          {subtitle && <Text className={classes.cardSub}>{subtitle}</Text>}
        </Box>
      </Flex>
      {right}
    </Flex>
  )
}
